export default [{
        path: '/myIndex',
        name: '个人中心',
        meta: {
            showFooter: true
        },
        component: () => import('../../views/my/index.vue'),
        children: [{
                path: '',
                redirect: '/service'
            },
            {
                path: '/service',
                name: '服务中心',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/service.vue')
            },
            {
                path: '/report',
                name: '我的报告',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/report.vue')
            },
            {
                path: '/datum',
                name: '我的资料',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/datum.vue')
            },
            {
                path: '/guanZhu',
                name: '我的关注',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/guanZhu.vue')
            },
            {
                path: '/safety',
                name: '安全中心',
                meta: {
                    showFooter: true
                },
                component: () => import('../../views/my/safety.vue')
            },
            {
                path: '/system',
                name: '绑定系统卡',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/system.vue')
            },
            {
                path: '/myUse',
                name: '使用',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/shiYong.vue')
            },
            {
                path: '/myBinding',
                name: '绑定系统卡',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/bangDing.vue')
            },
            {
                path: '/myRecord',
                name: '购买服务记录',
                meta: {
                    needLogin: true,
                    showFooter: true
                },
                component: () => import('../../views/my/gouMai.vue')
            }
        ]
    },
    {
        path: '/gaokao',
        name: '高考选科测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/gaokao/gaokao.vue')
    }, {
        path: '/gktest',
        name: '开始测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/gaokao/gaokTest.vue')
    }, {
        path: '/gktesta',
        name: '学科水平',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/gaokao/gkTestA.vue')
    }, {
        path: '/gktestb',
        name: '学科兴趣',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/gaokao/gkTestB.vue')
    }, {
        path: '/gktestc',
        name: '学科兴趣',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/gaokao/gkTestC.vue')
    }, {
        path: '/gktestd',
        name: '职业性格',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/gaokao/gkTestD.vue')
    }, {
        path: '/major',
        name: '根据科目选专业',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/gaokao/selMajor.vue')
    }, {
        path: '/subject',
        name: '根据专业选科目',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/gaokao/selSubject.vue')
    }, {
        path: '/situationIndex',
        name: '家长情况测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/situation/index.vue')
    }, {
        path: '/guideinfo',
        name: '升学途径指南详情',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/enterGuideInfo.vue')
    }, {
        path: '/guide',
        name: '升学途径',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/enterGuide.vue')
    }, {
        path: '/situationTest',
        name: '家长情况测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/situation/test.vue')
    }, {
        path: '/lastIndex',
        name: '智能填报测评',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/last/index.vue')
    }, {
        path: '/way',
        name: '升学途径分析测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/enterWay.vue')
    },
    {
        path: '/entertest',
        name: '测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/enterTest.vue')
    }, {
        path: '/waytesta',
        name: '基本信息',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/wayTestA.vue')
    }, {
        path: '/waytestb',
        name: '身体条件',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/wayTestB.vue')
    }, {
        path: '/lastSchool',
        name: '高校查询',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/last/school.vue')
    }, {
        path: '/lastRanking',
        name: '大学排名',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/last/ranking.vue')
    }, {
        path: '/lastMajor',
        name: '专业查询',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/last/major.vue')
    }, {
        path: '/waytestc',
        name: '家庭条件',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/wayTestC.vue')
    }, {
        path: '/waytestd',
        name: '个人能力',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/wayTestD.vue')
    }, {
        path: '/wayteste',
        name: '个人意愿',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/enter/wayTestE.vue')
    }, {
        path: '/style',
        name: '测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/style.vue')
    }, {
        path: '/styletest',
        name: '开始测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/styleTest.vue')
    }, {
        path: '/timemagn',
        name: '学习时间管理测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/timeMagn.vue')
    }, {
        path: '/timetest',
        name: '时间管理测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/timeTest.vue')
    }, {
        path: '/mind',
        name: '学业心理调节测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/mind.vue')
    }, {
        path: '/mindtest',
        name: '心理测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/mindTest.vue')
    }, {
        path: '/location',
        name: '专业定位测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/career/location.vue')
    }, {
        path: '/locationtest',
        name: '开始测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/career/locationTest.vue')
    }, {
        path: '/fileindex',
        name: '学生档案',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/file/fileIndex.vue')
    }, {
        path: '/file',
        name: '学生学情档案',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/file/file.vue')
    }, {
        path: '/occupation',
        name: '职业查询',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/occupation.vue')
    }, {
        path: '/constitution',
        name: '招生章程',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/constitution.vue')
    }, {
        path: '/lastYuan',
        name: '智能选院校',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/yuan.vue')
    }, {
        path: '/lastZy',
        name: '智能选专业',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/zy.vue')
    }, {
        path: '/assessment',
        name: '录取风险评估',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/assessment.vue')
    }, {
        path: '/lastGo',
        name: '同分数考生去向',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/go.vue')
    }, {
        path: '/volunteer',
        name: '一键志愿填报',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/volunteer.vue')
    }, {
        path: '/majorDetails',
        name: '详情',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/majorDetails.vue')
    }, {
        path: '/grade',
        name: '成绩信息',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/file/grade.vue')
    }, {
        path: '/general',
        name: '综合信息',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/file/general.vue')
    }, {
        path: '/direction',
        name: '学生学情档案',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/file/direction.vue')
    }, {
        path: '/relation',
        name: '关系测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/relation.vue')
    }, {
        path: '/relationtest',
        name: '开始关系测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/relationTest.vue')
    }, {
        path: '/relationa',
        name: '同学关系测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/relationa.vue')
    }, {
        path: '/relationb',
        name: '师生关系测试',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/work/relationb.vue')
    },
    // {
    //     path: '/volunteerTb',
    //     name: '志愿填报',
    //     meta: {
    //         needLogin: true,
    //         showFooter: true
    //     },
    //     component: () => import('../../views/my/last/volunteerTb.vue')
    // },
    {
        path: '/xzTianBaoIndex',
        name: '志愿填报',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/yunYing/tianBaoIndex.vue')
    },
    {
        path: '/xzTianBao',
        name: '志愿填报',
        meta: {
            needLogin: true,
            showFooter: true,
            name: '一键志愿填报'
        },
        component: () => import('../../views/my/yunYing/tianBao.vue')
    },
    {
        path: '/volunteerb',
        name: '填报批次',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/volunteerB.vue')
    }, {
        path: '/occupationDetails',
        name: '详情',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/occupationDetails.vue')
    }, {
        path: '/volunteerc',
        name: '填写志愿表',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/volunteerC.vue')
    }, {
        path: '/goDetails',
        name: '详情',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/goDetails.vue')
    }, {
        path: '/volunteerd',
        name: '生成志愿表',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/volunteerD.vue')
    }, {
        path: '/majorScore',
        name: '专业分数线',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/last/majorScore.vue')
    }, {
        path: '/skScore',
        name: '省控分数线',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/last/skScore.vue')
    }, {
        path: '/scoreTable',
        name: '一分一段表',
        meta: {
            needLogin: true,
            showFooter: false
        },
        component: () => import('../../views/my/last/scoreTable.vue')
    }, {
        path: '/schoolinfo',
        name: '学校介绍',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/yunYing/schoolInfo.vue')
    }, {
        path: '/majorinfo',
        name: '专业介绍',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/yunYing/majorInfo.vue')
    }, {
        path: '/znZhuan',
        name: '智能选专业',
        meta: {
            needLogin: true,
            showFooter: true,
            name: '一键志愿填报'
        },
        component: () => import('../../views/my/yunYing/znZhuan.vue')
    }, {
        path: '/znYuan',
        name: '智能选院校',
        meta: {
            needLogin: true,
            showFooter: true,
            name: '一键志愿填报'
        },
        component: () => import('../../views/my/yunYing/znYuan.vue')
    }, {
        path: '/jthomeJiaTing',
        name: '家庭学习与支持测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/aJiaTing.vue')
    }, {
        path: '/jthomeJiaTingEnd',
        name: '家庭学习与支持测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/aJiaTing_end.vue')
    }, {
        path: '/jthomeQinZi',
        name: '亲子关系测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/bQinZi.vue')
    }, {
        path: '/jthomeQinZiEnd',
        name: '亲子关系测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/bQinZi_end.vue')
    }, {
        path: '/jthomeHuanJing',
        name: '家庭环境测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/cHuanJing.vue')
    }, {
        path: '/jthomeHuanJingEnd',
        name: '家庭环境测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/cHuanJing_end.vue')
    }, {
        path: '/jthomeGongNeng',
        name: '家庭功能测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/dGongNeng.vue')
    }, {
        path: '/jthomeGongNengEnd',
        name: '家庭功能测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/dGongNeng_end.vue')
    }, {
        path: '/jthomeeZiPing',
        name: '青少年上瘾自评测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/eZiPing.vue')
    }, {
        path: '/jthomeeZiPingEnd',
        name: '青少年上瘾自评测评',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anJiaTing/eZiPing_end.vue')
    }, {
        path: '/kyStudyGaoKao',
        name: '新高考选科测评卡',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anKaoYan/aGaoKao.vue')
    }, {
        path: '/kyStudyShengXue',
        name: '升学规划测评卡',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anKaoYan/bShengXue.vue')
    }, {
        path: '/kyStudyGuiHua',
        name: '学业规划测评卡',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anKaoYan/cGuiHua.vue')
    }, {
        path: '/kyStudyZhiYe',
        name: '职业规划测评卡',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anKaoYan/dZhiYe.vue')
    }, {
        path: '/kyStudyKaoYan',
        name: '考研',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anKaoYan/eKaoYan.vue')
    }, {
        path: '/myClassVip',
        name: '课程',
        meta: {
            needLogin: true,
            showFooter: true
        },
        component: () => import('../../views/my/anClass/vip.vue')
    }
];
